import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Utils from '../shared/utils';
import { availabilityApiUrl } from '../config/api.config';
import { PricingScheme } from '../models/pricing-schema.model';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityProvider {
  constructor(private http: HttpClient) {}

  loadAvailability(from: Date, to: Date, optionId: number, currency: string): Promise<AvailabilityResponseModel> {
    const request = new AvailabilityRequestModel(from, to, optionId, currency);

    return this.http.get<AvailabilityResponseModel>(availabilityApiUrl, { params: request.toParams() }).toPromise();
  }
}

class AvailabilityRequestModel {
  constructor(private from: Date, private to: Date, private optionId: number, private currency: string) {
    if (from > to) {
      throw new Error('AvailabilityRequestModel: `to` has to be later than `from`');
    }

    if (optionId <= 0) {
      throw new Error('AvailabilityRequestModel: `optionId` has to be a positive number');
    }
  }

  toParams(): Record<string, string> {
    return {
      from: Utils.getFormatedDate(this.from),
      to: Utils.getFormatedDate(this.to),
      optionId: this.optionId.toString(),
      currency: this.currency,
    };
  }
}

interface AvailabilityResponseModel {
  availabilities: AvailabilityModel[];
}

export interface AvailabilityModel {
  day: string; // "yyyy-MM-dd"
  startTime?: TimeSpan;
  endTime?: TimeSpan;
  startDate: Date;
  endDate: Date;
  availableCapacity: number;
  pricingSchemas: PricingScheme[];
  languages: string[]; // ["en", "ro", "ru"]
}

type TimeSpan = string; // "12:00:00"
